import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_OPS_INT_ACTION: string = "OpsIntActionChannel";
export type OpsIntActionResponse = CubiqTS.ServiceResponse | CubiqTS.ServiceResponse[] | void;
export interface IOpsIntActionService {
  cancelOrder(opsIntId: string[]): Promise<OpsIntActionResponse>;
  clear(
    opsIntId: string[],
    comment: string,
    externalDealId: string,
    options: object,
  ): Promise<OpsIntActionResponse>;
  reprice(opsIntId: string[]): Promise<OpsIntActionResponse>;
  resend(opsIntId: string[]): Promise<OpsIntActionResponse>;
}
